<template lang="pug">
.tbk-report.pt-2
  v-form(ref="form")
    v-layout(wrap)
      v-flex.xs6.px-3
        DateField(
          outline
          :rules="rules"
          :disabled="loading"
          v-model="date1")
      v-flex.xs6.px-3
        DateField(
          outline
          :disabled="loading"
          :rules="rules"
          v-model="date2")
      v-flex.xs6.pl-3
        v-btn.success(
          block
          @click="handleButton"
          :disabled="loading"
          ) CARGAR REPORTE
      v-flex.xs6.pr-3
        v-btn.secondary(
          block
          :rules="rules"
          @click="handleExcel"
          :disabled="loading"
          ) DESCARGAR EXCEL DEPÓSITOS
  span.ml-2(
    v-if="rows.length"
    ) {{rows.length}} Registros Encontrados
  ModelDataTable( 
    :headers="headers"
    no-actions
    v-model="rows"
    no-pagination
    :rows-per-page="-1"
    no-search
    no-fiter
    )   
</template>

<script>
import ModelDataTable from '@/components/reusable_components/next/ModelDataTable'
import DateField from '@/components/reusable_components/next/Fields/DateField'
import axios from 'axios'
import { mapActions, mapGetters } from 'vuex'
import headers from './tbkReportHeaders'

const initialState = () => ({
    showAuth: true,
    loading: false,
    date1: '',
    date2: '',

    rows: [],
    headers,
})

export default {
    name: 'transbank_report',
    components: { ModelDataTable, DateField },
    data: () => initialState(),
    computed: {
        ...mapGetters('AuthModule', ['branchOfficeId']),
        rules() {
            return [
                v => !!v || 'Campo Obligatorio',
                v =>
                    this.dateIsGreaterOrEqualThan(this.date2, this.date1)
                        ? true
                        : 'La fecha de fin debe ser posterior a la fecha de inicio',
            ]
        },
    },
    methods: {
        ...mapActions('UniqueKeyModule', {
            authorize: 'authorize',
            setPermission: 'setPermission',
            setUniqueKey: 'setUniqueKey',
        }),
        ...mapActions('SnackbarModalModule', {
            initSnackbar: 'initSnackbar',
            resetSnackbarState: 'resetSnackbarState',
        }),
        ...mapActions('MenuesModule', {
            setTitleTopBar: 'setTitleTopBar',
        }),
        formatDate(date) {
            let month = '' + (date.getMonth() + 1)
            let day = '' + date.getDate()
            let year = date.getFullYear()
            if (month.length < 2) month = '0' + month
            if (day.length < 2) day = '0' + day
            return [year, month, day].join('-')
        },
        dateIsGreaterOrEqualThan(date1, date2) {
            let d1 = new Date(date1).getTime()
            let d2 = new Date(date2).getTime()
            return d1 >= d2
        },
        fetchReport() {
            this.loading = true
            let route =
                process.env.VUE_APP_API_ROUTE +
                '/g_transbank_deposit_summary_report'
            axios
                .post(route, {
                    start_date: this.date1,
                    end_date: this.date2,
                    branch_office_id: this.branchOfficeId,
                })
                .then(r => {
                    if (r.data && r.data.length) this.rows = r.data
                    else {
                        this.resetSnackbarState()
                        let payload = {
                            typeMessage: 'info',
                            message: {
                                title: 'Sin Registros',
                                body:
                                    'No se encontraron registros para el rango de fechas seleccionado',
                            },
                            timeout: 6000,
                            showProgress: false,
                            showCloseBtn: true,
                            closeBtnMessage: 'cerrar',
                        }
                        setTimeout(() => this.initSnackbar(payload), 100)
                    }
                })
                .catch(console.log)
                .finally(() => (this.loading = false))
        },
        fetchExcel() {
            this.loading = true
            axios({
                url:
                    process.env.VUE_APP_API_ROUTE +
                    '/g_transbank_deposit/excel' +
                    `?start_date=${this.date1}` +
                    `&end_date=${this.date2}` +
                    `&branch_office_id=${this.branchOfficeId}`,
                method: 'GET',
                responseType: 'blob', // important
            })
                .then(response => {
                    const url = window.URL.createObjectURL(
                        new Blob([response.data])
                    )
                    const link = document.createElement('a')
                    link.href = url
                    link.setAttribute(
                        'download',
                        `depositos_transbank_${this.date1}_al_${
                            this.date2
                        }.xlsx`
                    )
                    document.body.appendChild(link)
                    link.click()
                })
                .catch(console.log)
                .finally(() => (this.loading = false))
        },
        handleButton() {
            if (this.$refs.form.validate()) this.fetchReport()
        },
        handleExcel() {
            if (this.$refs.form.validate()) this.fetchExcel()
        },
    },
    watch: {
        loading(v) {
            if (v) {
                this.resetSnackbarState()
                let payload = {
                    typeMessage: 'info',
                    message: {
                        title: 'Cargando Reporte',
                        body: '',
                    },
                    timeout: 0,
                    showProgress: true,
                    showCloseBtn: false,
                    closeBtnMessage: 'cerrar',
                }
                this.initSnackbar(payload)
            } else {
                this.resetSnackbarState()
            }
        },
    },
    created() {
        this.setTitleTopBar('Seguimiento Transbank')
        this.date1 = this.formatDate(new Date())
        this.date2 = this.formatDate(new Date())
        this.fetchReport()
    },
}
</script>
